import { v7 as uuidv7 } from "uuid";
import { z } from "zod";
import { honsenOrRampEnum } from "./honsenOrRamp";
import { placeTypeEnum } from "./placeType";
import { roadTypeEnum } from "./roadType";

export const flagRowSchema = z.object({
  id: z.string().uuid(),
  quantityId: z.string().uuid(),
  roadType: roadTypeEnum,
  honsenOrRamp: honsenOrRampEnum,
  icJCTName: z.string().nullish(),
  rampName: z.string().nullish(),
  startKiloPost: z.number().nullish(),
  endKiloPost: z.number().nullish(),
  modifiedStartKiloPost: z.number().nullish(),
  modifiedEndKiloPost: z.number().nullish(),
  dateFirst: z.coerce.date().nullish(),
  dateSecond: z.coerce.date().nullish(),
  dateThird: z.coerce.date().nullish(),
  dateFourth: z.coerce.date().nullish(),
  sortOrder: z.number(),
  positionX: z.number().nullish(),
  positionY: z.number().nullish(),
  placeType: placeTypeEnum,
  createdAt: z.coerce.date().default(new Date()),
  updatedAt: z.coerce.date().default(new Date()),
});

export const newFlagRowInputSchema = flagRowSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export const editFlagRowInputSchema = flagRowSchema.pick({
  roadType: true,
  honsenOrRamp: true,
});

export type FlagRow = z.infer<typeof flagRowSchema>;
export type FlagRowInput = z.input<typeof flagRowSchema>;
export type NewFlagRowInput = z.input<typeof newFlagRowInputSchema>;

export const createFlagRow = (input: NewFlagRowInput): FlagRow => {
  return newFlagRow({
    ...input,
    id: uuidv7(),
  });
};

export const newFlagRow = (input: FlagRowInput): FlagRow => flagRowSchema.parse(input);
